import { Component, OnInit, Input, OnDestroy } from "@angular/core";
import { NewAlertModel } from "./utils/new-alert-model";
import { Subscription } from "rxjs";
import { Router, NavigationStart } from "@angular/router";
import { NewAlertType } from "./utils/new-alert-type";
import { NewAlertService } from "./new-alert.service";

@Component({
    selector: "app-new-alert",
    templateUrl: "./new-alert.component.html",
    styleUrls: ["./new-alert.component.css"]
})
export class NewAlertComponent implements OnInit, OnDestroy {
    @Input() id = "default-alert";
    @Input() fade = true;

    private timeToClose: number = 6000;

    alerts: NewAlertModel[] = [];
    notifications: NewAlertModel[] = [];
    alertSubscription: Subscription;
    notificationSubscription: Subscription;
    routeSubscription: Subscription;
    marginTop: number = NewAlertService.length * 70;

    constructor(
        private router: Router,
        private alertService: NewAlertService
    ) {}

    ngOnInit() {
        this.alertSubscription = this.alertService
            .onAlert(this.id)
            .subscribe(alert => {
                if (!alert.message) {
                    this.alerts = this.alerts.filter(
                        x => x.keepAfterRouteChange
                    );

                    this.alerts.forEach(x => delete x.keepAfterRouteChange);
                    return;
                }

                this.alerts.push(alert);

                if (alert.autoClose) {
                    setTimeout(() => this.removeAlert(alert), this.timeToClose);
                }
            });

        this.notificationSubscription = this.alertService
            .onNotification(this.id)
            .subscribe(notification => {
                if (!notification.message)
                {
                    this.notifications = this.notifications.filter(
                        x => x.keepAfterRouteChange
                    );

                    this.notifications.forEach(
                        x => delete x.keepAfterRouteChange
                    );

                    return;
                }
                this.notifications.push(notification);
                if (notification.autoClose) {
                    setTimeout(() => this.removeNotification(notification), this.timeToClose);
                }
            });

        this.routeSubscription = this.router.events.subscribe(event => {
            if (event instanceof NavigationStart) {
                this.alertService.clear(this.id);
            }
        });
    }

    ngOnDestroy() {
        this.notificationSubscription.unsubscribe();
        this.alertSubscription.unsubscribe();
        this.routeSubscription.unsubscribe();
    }

    removeAlert(alert: NewAlertModel) {
        if (!this.alerts.includes(alert)) return;

        if (this.fade) {
            this.alerts.find(x => x === alert).fade = true;

            setTimeout(() => {
                this.alerts = this.alerts.filter(x => x !== alert);
            }, 250);
        } else {
            this.alerts = this.alerts.filter(x => x !== alert);
        }
    }

    removeNotification(notification: NewAlertModel) {
        if (!this.notifications.includes(notification)) return;

        if (this.fade) {
            this.notifications.find(x => x === notification).fade = true;

            setTimeout(() => {
                this.notifications = this.notifications.filter(
                    x => x !== notification
                );
            }, 250);
        } else {
            this.notifications = this.notifications.filter(
                x => x !== notification
            );
        }
    }

    cssClass(alert: NewAlertModel) {
        if (!alert) return;

        const classes = ["alert", "alert-dismissable"];

        const alertTypeClass = {
            [NewAlertType.Success]: "alert alert-success",
            [NewAlertType.Error]: "alert alert-danger",
            [NewAlertType.Info]: "alert alert-info",
            [NewAlertType.Warning]: "alert alert-warning"
        };

        classes.push(alertTypeClass[alert.type]);

        if (alert.fade) {
            classes.push("fade");
        }

        return classes.join(" ");
    }
}
